import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { EnrollmentAcceptedStudentService } from 'src/app/service/enrollmentAcceptedStudent.service';
import { FileService } from 'src/app/service/file.service';
import { CoursesService } from 'src/app/service/courses.service';


import { environment } from 'src/environments/environment';
import { Console } from 'console';
import { EnrollmentGroupService } from 'src/app/service/enrollment-group.service';
import { ThisReceiver } from '@angular/compiler';
import { forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

// Excel sheet export
import { Cell, Workbook } from 'exceljs';
import * as fs from 'file-saver';
import { AttendanceService } from 'src/app/service/attendance.service';
import { ScoresService } from 'src/app/service/scores.service';
import { AcademicsService } from 'src/app/service/academics.service';

declare var $: any;
@Component({
  selector: 'app-warning-letters',
  templateUrl: './warning-letters.component.html',
  styleUrls: ['./warning-letters.component.scss']
})
export class WarningLettersComponent implements OnInit {

  letterHtml:any;
  select: any;
  showLoader: boolean = false;
  searched: boolean = false;
  repeaterPage: boolean = false;
  generatingReport: boolean = false;
  searchByFields: any;
  students: any = [];
  table: any;
  years: any;
  semesters: any;
  batches: any;
  filterType: any;
  orgId: any;
  username: any;
  warningLetters: any = [];

  ScheduleHeader: any;
  currentWLetter:any;

  currentYear: any;
  currentSemester: any;
  currentBatch: any;
  currentStudent: any;
  currentGroup: any;
  currentDate: any;
  currentLang: any;

  excelHeaderName: any;

  filterTypes: any;

  courses: any = [];
  letterTypes: any = [];
  allstudents: any = [];
  teachers: any = [];

  photoPath: any = `${environment.API_URL_UTIL}/api/downloadFile/`;

  groups: any = [];

  searchForm = new FormGroup({
    year: new FormControl('', [
      Validators.required,
    ]),
    semester: new FormControl('', [
      Validators.required,
    ]),
    batch: new FormControl('', [
      Validators.required,
    ]),
    // group: new FormControl('0', [
    //   // Validators.required,
    // ]),
    student: new FormControl('0', [
      // Validators.required,
    ]),
    filterType: new FormControl('0', [
      // Validators.required,
    ]),
  });

  constructor(
    private academicsService:AcademicsService,
    private scoresService:ScoresService,
    private activatedRoute: ActivatedRoute,
    private attendance: AttendanceService, private toastrService: ToastrService, public enrollmentAcceptedStudentService: EnrollmentAcceptedStudentService, public globals: Globals, private router: Router, public translate: TranslateService, private fileService: FileService, private enrollmentGroupService: EnrollmentGroupService, private coursesService: CoursesService) { }

  ngOnInit(): void {
    this.orgId = this.globals.currentUserInfo.orgid;
    this.username = this.globals.currentUserInfo.username;
    this.currentLang = this.globals.lang;
    this.searched=false;
    this.activatedRoute
    .queryParams
    .subscribe(params => {
      this.currentYear = params['yearId'] || "";
      this.currentSemester = params['semesterId'] || "";
      this.currentBatch = params['batchId'] || "";
      // this.currentGroup = params['groupId'] || "";
      this.currentStudent = params['studentId'] || "";
      this.currentWLetter = params['typeId'] || "";

      this.searchForm.controls.year.setValue(this.currentYear);
      this.searchForm.controls.semester.setValue(this.currentSemester);
      this.searchForm.controls.batch.setValue(this.currentBatch);
      // this.searchForm.controls.group.setValue(this.currentGroup);
      this.searchForm.controls.student.setValue(this.currentStudent);
      this.searchForm.controls.filterType.setValue(this.currentWLetter);

      this.getYears();
      if(this.searchForm.controls.semester.value.length > 0){
        this.getYearSemesters();
      }
      if(this.searchForm.controls.batch.value.length > 0){
        this.getBatches();
      }
      // if(this.searchForm.controls.group.value.length > 0){
      //   this.getBatchGroups();
      // }
      if(this.searchForm.controls.student.value.length > 0){
        this.getStudentsByBatch();
      }
    });

   // this.getYears();
   // this.initFilterTypeValues();

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.updateTable();
      //this.initFormDropDownsFields();
    });
  }



  updateTable() {
    if (this.table) {
      this.table.destroy();
    } else { $("#datatable").DataTable().destroy(); }

    setTimeout(() => {
      this.table = $("#datatable").DataTable({
        // columnDefs: [{
        //   orderable: false,
        //   className: 'select-checkbox',
        //   targets: 0
        // }],
        // select: {
        //   style: 'multi',
        //   selector: 'td:first-child',
        //   blurable: false
        // },
        // select: true,
        dom: 'Bfrtip',
        pagingType: 'simple_numbers',
        // responsive: true,
        // columnDefs: [
        //   { responsivePriority: 1, targets: 0 },
        //   { responsivePriority: 10001, targets: 4 },
        //   { responsivePriority: 2, targets: -2 }
        // ],
        // rowReorder: true,
        // "columnDefs": [
        //   { orderable: true, className: 'reorder', targets: [0] },
        //   { orderable: false, targets: '_all' }
        // ],
        // pageLength: 5,
        paging: false,
        searching: true,
        ordering: true,
        lengthChange: false,
        info: true,
        search: {
          searchPlaceholder: "Search",
        },
        language: {
          search: "",
          searchPlaceholder: "Search",
        },
        buttons: [{
          extend: 'excelHtml5',
          text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
          titleAttr: 'EXCEL',
          exportOptions: {
            columns: [0, 1, 2]
          },
          className: 'datatable_custom_buttons',
        }],
      })
    }, 1);

  }

  searchFormChange() {
  }

  searchFormSubmit() {
    this.warningLetters =[];
    this.searched=true;
    this.showLoader = true;
    if (this.searchForm.valid) {
      
      this.currentYear = this.searchForm.controls.year.value;
      this.currentSemester = this.searchForm.controls.semester.value;
      this.currentBatch = this.searchForm.controls.batch.value;
      this.filterType = this.searchForm.controls.filterType.value.length > 0 ? this.searchForm.controls.filterType.value : 0;
      // this.currentGroup = this.searchForm.controls.group.value.length > 0 ? this.searchForm.controls.group.value : 0;
      this.currentGroup = 0;
      this.currentStudent = this.searchForm.controls.student.value.length > 0 ? this.searchForm.controls.student.value : 0;
      this.scoresService.searchForWarrningLetter(10,this.currentYear,this.currentSemester,this.currentBatch,this.filterType,this.currentGroup,this.currentStudent)
      .subscribe(
        data => {
          data = data.map((element: any) => {
            // console.log(element);
           // let mgroupid = element.mgroupid;
            let course = this.courses.filter((i: any) => i.id == element.subjectid)[0];
            let student = this.students.filter((i: any) => i.id == element.studentid)[0];
            let letterType = this.letterTypes.filter((i: any) => i.id == element.warntypeid)[0];
            let teacher = this.teachers.filter((i: any) => i.id == element.teacherid)[0];
            return {...element, course,student,letterType,teacher};
          });
          this.warningLetters = data;
          console.log(this.warningLetters);
          this.updateTable();
          this.showLoader = false;
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          this.searched=false;
        }
      );
    } else {
      this.searchForm.markAllAsTouched();
      this.searchForm.markAsDirty();
    }
  }

  

  getYears() {
    this.enrollmentGroupService.getYears()
      .subscribe(
        data => {
          this.years = data;
          this.getAllCourses();
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }

  getYearSemesters() {
    let year = this.searchForm.controls.year.value;
    if (year) {
      this.enrollmentGroupService.getYearSemesters(year)
        .subscribe(
          data => {
            this.semesters = data;
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    } else {
      this.searchForm.controls.semester.reset();
      this.semesters = [];
    }
  }

  getBatches() {
    let year = this.searchForm.controls.year.value;
    let semester = this.searchForm.controls.semester.value;
    if (year && semester) {
      this.enrollmentGroupService.getSemesterBatches(this.orgId, year, semester)
        .subscribe(
          data => {
            this.batches = data;
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    } else {
      this.searchForm.controls.batch.reset();
      this.batches = [];
    }
  }

  getBatchGroups() {
    // this.searchForm.controls.group.setValue('');
    // this.searchForm.controls.student.setValue('');
    let batch = this.searchForm.controls.batch.value;
    if (batch) {
      this.attendance.getBatchGroups(this.orgId, batch)
        .subscribe(
          data => {
            this.groups = data;
         //   this.getStudentsByGroup();
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    } else {
      this.searchForm.controls.group.reset();
      this.groups = [];
    }
  }

  getStudentsByBatch() {
   // this.searchForm.controls.student.setValue('');
    // let groupid = this.searchForm.controls.group.value > 0 ? this.searchForm.controls.group.value : 0;
    let groupid = 0;
    let yearid = this.searchForm.controls.year.value;
    let semesterid = this.searchForm.controls.semester.value;
    let batchid = this.searchForm.controls.batch.value;
    if (yearid && semesterid && batchid) {
      this.scoresService.getGradeStudents(this.orgId, yearid, semesterid, batchid)
        .subscribe(
          data => {
            this.allstudents = data;
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    } else {
      this.searchForm.controls.student.reset();
      this.allstudents = [];
    }
  }

  // initFilterTypeValues() {
  //   this.filterTypes = [
  //     {
  //       key: "ALL",
  //       name: this.translate.instant("ALL")
  //     },
  //     {
  //       key: "Clinical",
  //       name: this.translate.instant("CLINICAL")
  //     },
  //     {
  //       key: "Theory",
  //       name: this.translate.instant("THEORY")
  //     }
  //   ];
  // }

  print(id: number){
    console.log("print letter ....");
   // this.showLoader = true;
    this.scoresService.getWarrningLetterPrintHtml(id).subscribe(
      data => {
        this.letterHtml=data[0];
        
     },
     error => {
       this.showLoader = false;
       this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
     }
   );
  }

  printValu(){
    console.log("print value ....");

  }

  approveWarningLetter(id: number){
   console.log("call approve letter API ... >> ID: " + id);
   this.getWarningLetterById(id);
   
  }

  getWarningLetterById(letterId: number) {
    this.showLoader = true;
    this.scoresService.getWarrningLetterById(letterId).subscribe(
      data => {
        console.log(data);
        this.currentWLetter=data;
        this.currentWLetter.warnStatus="FINAL";
        this.updateWarningLetter(this.currentWLetter,letterId);
        
     },
     error => {
       this.showLoader = false;
       this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
     }
   );
  }

   updateWarningLetter(scoreData: string,letterId:any) {
    //  this.updating = true;
     let username = this.globals.currentUserInfo.username;
     this.scoresService.updateWarrningLetter(username,letterId, 10, scoreData,this.currentYear,this.currentSemester,this.currentBatch)
      .subscribe(
        data => {
          console.log(data);
          if (data.sts == "SUCCESS") {
            if (this.globals.lang == "ar") {
              this.toastrService.success(data.arMsg);
            } else {
              this.toastrService.success(data.enMsg);
            }
            this.searchFormSubmit();
            
          } else {
            if (this.globals.lang == "ar") {
              this.toastrService.error(data.arMsg);
            } else {
              this.toastrService.error(data.enMsg);
            }
          }
          // this.updating = false;
        },
         error => {
          //  this.updating = false;
           this.toastrService.error(this.translate.instant('FAIL_TO_UPDATE'));
         }
       );
  }

  getAllCourses() {
    this.showLoader = true;
    this.coursesService.getAllCourses()
      .subscribe(
        data => {
          this.courses = data;
          this.getAllStudent();
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }

  getAllStudent() {
    this.enrollmentAcceptedStudentService.getAllStudents()
      .subscribe(
        data => {
          this.students = data;
          this.getLetterTypes();
        },
        error => {
          this.students = [];
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }

  getLetterTypes() {
    //this.letterTypes = [];
    console.log("innnnnnnnnn");
    this.scoresService.getAllWLetterTypes()
      .subscribe(
        data => {
          console.log("innnnnnnnnn2");
          this.letterTypes = data;
          this.getAllTeacher();
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
      
  }

  getAllTeacher(){
    this.academicsService.getTeachers()
    .subscribe(
      data => {
        if (data && data.length) {
            this.teachers = data;
        }

      },
      error => {

        this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        // this.showLoader = false

      },
      // () => this.showLoader = false
    );
    this.showLoader = false;
   
  }


}


